import { URL_API } from '../../../constants';
import { chatgenieAPI } from '../../../services/chatgenieAPI';
import { usersTypes } from '../../types';

export const getInfo = () => dispatch =>
  dispatch({
    type: usersTypes.SIGN_IN,
    payload: chatgenieAPI.instance({
      method: 'GET',
      url: `${URL_API}/api/users/info`
    })
  });

export const saveToken = token => ({
  type: usersTypes.SAVE_TOKEN,
  payload: { token }
});

export const saveAppId = ({ appId }) => ({
  type: usersTypes.SAVE_APP_ID,
  payload: { appId }
});

export const switchWorkspace = () => ({
  type: usersTypes.SWITCH_WORKSPACE
});

export const setIsSigningOut = payload => ({
  type: usersTypes.SET_IS_SIGNING_OUT,
  payload
});
